import { useMemo } from "react";
import type { AudioCaptureOptions } from "livekit-client";
import {
  selectAudioInputId,
  selectNoiseSuppression,
  useLiveStore,
} from "../../store";

export const useLivekitMicrophoneCaptureOptions = () => {
  const noiseSuppression = useLiveStore(selectNoiseSuppression);
  const audioInputId = useLiveStore(selectAudioInputId);

  const isBasic = noiseSuppression === "basic";
  const isAdvanced = noiseSuppression === "advanced";
  const shouldEnableNoiseSuppression = isBasic || isAdvanced;

  const captureOptions = useMemo<AudioCaptureOptions>(
    () => ({
      noiseSuppression: shouldEnableNoiseSuppression,
      echoCancellation: shouldEnableNoiseSuppression,
      autoGainControl: shouldEnableNoiseSuppression,
      deviceId: audioInputId,
    }),
    [shouldEnableNoiseSuppression, audioInputId],
  );

  return {
    captureOptions,
    isAdvancedNoiseSuppression: isAdvanced,
  };
};
